import { observer } from "mobx-react";
import React from "react";
import { Modal } from "@mantine/core";
import { Cubby } from "../../stores/Cubby";
import { MODALS } from "../../helpers/constants";

import EditNostrConnectionForReceiveOnly from "./editNostrConnectionForReceiveOnly";
import EditNostrConnectionForSendAndReceive from "./editNostrConnectionForSendAndReceive";
import ShowNostrConnection from "./showNostrConnection";

interface EditNostrConnectionModalProps {
  cubby: Cubby;
}

const SingleNostrConnection = observer(
  ({ cubby }: EditNostrConnectionModalProps) => {
    const connection = cubby.selectedNostrConnection;

    return (
      <>
        {connection && (
          <Modal
            opened={cubby.currentModal === MODALS.SINGLE_NOSTR_CONNECTION}
            onClose={() => cubby.setModal(MODALS.CONNECT_APPS)}
            title={`${
              connection.editorialViewStatus === "edit"
                ? "Edit NWC Connection"
                : "Get NWC Connection Details"
            } `}
          >
            <>
              {connection.editorialViewStatus === "edit" &&
                connection.security_level_name === "receive_only" && (
                  <EditNostrConnectionForReceiveOnly cubby={cubby} />
                )}
              {connection.editorialViewStatus === "edit" &&
                connection.security_level_name === "send_and_receive" && (
                  <EditNostrConnectionForSendAndReceive cubby={cubby} />
                )}
              {connection.editorialViewStatus === "show" && (
                <ShowNostrConnection cubby={cubby} />
              )}
            </>
          </Modal>
        )}
      </>
    );
  }
);

export default SingleNostrConnection;
